/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { InvoicePaidStatus } from '@msdyn365-commerce/retail-proxy';

export interface IInvoiceStatusResources {
    invoiceStatusNone: string;
    invoiceStatusUnpaid: string;
    invoiceStatusPartiallyPaid: string;
    invoiceStatusPaid: string;
}

export const getInvoiceStatusText = (resources: IInvoiceStatusResources, invoiceStatus: InvoicePaidStatus | undefined) => {
    switch (invoiceStatus) {

        case 0 as InvoicePaidStatus.None:
            return resources.invoiceStatusNone;

        case 1 as InvoicePaidStatus.Unpaid:
            return resources.invoiceStatusUnpaid;

        case 2 as InvoicePaidStatus.PartiallyPaid:
            return resources.invoiceStatusPartiallyPaid;

        case 3 as InvoicePaidStatus.Paid:
            return resources.invoiceStatusPaid;
        default:
            return '';
    }
};
